module.exports = __webpack_public_path__ + "static/WDFH-a7159fb9efc6b713397e7d64763d7a62.jpg";